import React from "react";
import { Button, Card, Col, Row, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const DocumentAccepted = () => {
  const navigate = useNavigate();

  return (
    <div className="container mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow text-center">
            <Card.Body className="p-5">
              <div className="text-success mb-4">
                <i className="fa fa-check-circle fa-5x"></i>
              </div>
              
              <h2 className="text-success mb-3">Document Accepted Successfully!</h2>
              
              <Alert variant="success" className="mb-4">
                <p className="mb-0">
                  Thank you for accepting the document. Your acceptance has been recorded and 
                  the relevant parties have been notified.
                </p>
              </Alert>

              <div className="mb-4">
                <h5>What happens next?</h5>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <i className="fa fa-envelope me-2 text-primary"></i>
                    You will receive a confirmation email shortly
                  </li>
                  <li className="mb-2">
                    <i className="fa fa-users me-2 text-primary"></i>
                    HR team has been notified of your acceptance
                  </li>
                  <li className="mb-2">
                    <i className="fa fa-calendar me-2 text-primary"></i>
                    Further instructions will follow as needed
                  </li>
                </ul>
              </div>

              <div className="d-flex justify-content-center gap-3">
                <Button 
                  variant="primary" 
                  onClick={() => navigate('/')}
                >
                  <i className="fa fa-home me-2"></i>
                  Go to Homepage
                </Button>
                <Button 
                  variant="outline-secondary" 
                  onClick={() => window.close()}
                >
                  <i className="fa fa-times me-2"></i>
                  Close Window
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentAccepted;